import apiClient from './apiClient';
import type { Notification, NotificationListResponse, UnreadCountResponse } from '../../types/notifications';

const BASE = '/api/v1/notifications';

// Background requests skip the 401 → refresh → redirect cycle in the interceptor.
// Notification polling should fail silently, not force a logout.
const bgConfig = { _backgroundRequest: true } as any;

export const getNotifications = async (params?: {
  unreadOnly?: boolean;
}): Promise<NotificationListResponse> => {
  const response = await apiClient.get<NotificationListResponse>(BASE, {
    ...bgConfig,
    params: params?.unreadOnly ? { unreadOnly: 'true' } : undefined,
  });
  return response.data;
};

export const getUnread = async (): Promise<NotificationListResponse> => {
  const response = await apiClient.get<NotificationListResponse>(`${BASE}/unread`, bgConfig);
  return response.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const response = await apiClient.get<UnreadCountResponse>(`${BASE}/unread-count`, bgConfig);
  return response.data.data.count;
};

export const markAsRead = async (id: string): Promise<Notification> => {
  const response = await apiClient.patch<{ success: boolean; data: Notification }>(
    `${BASE}/${id}/read`,
  );
  return response.data.data;
};

export const markAllAsRead = async (): Promise<{ count: number }> => {
  const response = await apiClient.patch<{ success: boolean; data: { count: number } }>(
    `${BASE}/read-all`,
  );
  return response.data.data;
};

export const dismissNotification = async (id: string): Promise<Notification> => {
  const response = await apiClient.delete<{ success: boolean; data: Notification }>(
    `${BASE}/${id}`,
  );
  return response.data.data;
};

const notificationService = {
  getNotifications,
  getUnread,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  dismissNotification,
};

export default notificationService;
